/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { DataRest, DevicesThGroupsData, DevicesThGroupsV2Data, GetThLogResponseData, LogThExportData, ThDeviceStatus, UsersData } from '../model/api/data-rest';
import { resources } from './api';
import moment from 'moment';
import { Thermo } from '../model/thermo';


@Injectable({
	providedIn: 'root'
})

export class DeviceThService {
	constructor(
		private http: HttpClient
	) { }

	getDevicesThList():
		Observable<DevicesThGroupsData> {
		return this.http.get<DevicesThGroupsData>(`${environment.apiUrlThermo}${resources.get('groups')}${resources.get('get')}`, {});
	}

	getDevicesThListV2(userId: number):
		Observable<DevicesThGroupsV2Data> {
		let params = new HttpParams();
		if (userId) {
			params = params.set('userId', userId);
		}
		return this.http.get<DevicesThGroupsV2Data>(`${environment.apiUrlThermo}${resources.get('v2')}${resources.get('groups')}`, {params});
	}

	getDeviceThStatus(keycode: string):
		Observable<ThDeviceStatus> {
		return this.http.get<ThDeviceStatus>(`${environment.apiUrlThermo}${resources.get('devices')}/${keycode}`, {});
	}

	getLogThExport(keycode: string, startDate: Date, endDate: Date, metrics: string[]):
		Observable<LogThExportData> {
		let params = new HttpParams();
		/*params = params.set('startDate', moment(startDate).format('YYYY-MM-DDTHH:mm:ss'));
		params = params.set('endDate', moment(endDate).format('YYYY-MM-DDTHH:mm:ss'));*/
		params = params.set('from', moment(startDate).toISOString().replace('.000', ''));
		params = params.set('to', moment(endDate).toISOString().replace('.000', ''));
		if (metrics) {
			params = params.set('metrics', metrics.toString());
		}
		return this.http.get<LogThExportData>(`${environment.apiUrlThermo}${resources.get('api')}${resources.get('v1')}${resources.get('statistics')}/${keycode}${resources.get('download')}`, { params });
	}

	// TH log
	getThLog(keycode: string, from?: Date, intervaltype?: string, location?: string):
		Observable<GetThLogResponseData> {
		let params = new HttpParams();
		if (from) {
			params = params.set('from', from.toISOString());
		}
		if (intervaltype) {
			params = params.set('intervaltype', intervaltype);
		}
		if (location) {
			params = params.set('location', location);
		}
		return this.http.get<GetThLogResponseData>(`${environment.apiUrlThermo}${resources.get('api')}${resources.get('v1')}${resources.get('statistics')}/${keycode}`, { params });
	}

	getThermoDeviceV2(keycode: string, userId?: number): Observable<Thermo> { // fetch all thermo device info
		let params = new HttpParams();
		if (userId) {
			params = params.set('userId', userId);
		}
		return this.http.get<Thermo>(`${environment.apiUrlThermo}${resources.get('v2')}${resources.get('devices')}/${keycode}`, {params});
	}

	updateThermo(thermo: Thermo, userId?: number): Observable<DataRest> { // update thermo
		let params = new HttpParams();
		if (userId) {
			params = params.set('userId', userId);
		}
		return this.http.post<DataRest>(`${environment.apiUrlThermo}${resources.get('control')}/${thermo.keycode}/${thermo.keycode}`, thermo, { params });
	}

	setGroupSiteAssociation(siteId: number, groupId: number, userId?: number): Observable<DataRest> {
		let params = new HttpParams();
		if (userId) {
			params = params.set('userId', userId);
		}
		return this.http.post<DataRest>(`${environment.apiUrl}${resources.get('sites')}/${siteId}${resources.get('groups')}/${groupId}`, {}, { params });
	}

	getFinalUsersThGroup(thGroupId: number, userId?: number): Observable<UsersData> {
		let params = new HttpParams();
		if (userId) {
			params = params.set('userId', userId);
		}
		return this.http.get<UsersData>(`${environment.apiUrl}${resources.get('users')}${resources.get('groups')}/${thGroupId}${resources.get('finalusers')}`, { params });
	}

	removeShareThGroup(thGroupId: number, userDeleteId: number, userId?: number): Observable<DataRest> {
		let params = new HttpParams();
		if (userId) {
			params = params.set('userId', userId);
		}
		return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('sites')}${resources.get('groups')}/${thGroupId}${resources.get('finaluser')}/${userDeleteId}`, { params });
	}

	revokeShareInvitationThGroup(token: string, userId?: number): Observable<DataRest> {
		let params = new HttpParams();
		if (userId) {
			params = params.set('userId', userId);
		}
		return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('invitations')}/${token}`, { params });
	}
}
